import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import * as publicacionesService from '../../servicios/publicacionesService'
import ToolTip from '../../ui/ToolTip'

const Exposicion = ({ idExposicionNueva, onChangeState }) => {
  const [exposiciones, setExposiciones] = useState([])

  useEffect(() => {
    const obtenerExposiciones = async () => {
      const exposicionRtn = await publicacionesService.buscarExposicion('')
      setExposiciones(exposicionRtn.data)
    }

    obtenerExposiciones()
  }, [])

  const handleChange = (value) => {
    onChangeState(value.name, parseInt(value.value))
  }

  return (
    <div className="row">
      <div className="col">
        <div className="col">
          {exposiciones.map((exposicion) => (
            <ToolTip key={exposicion.idPublicacionExposicion}>
              <span>
                <input
                  className="ml-2 mr-2"
                  type="radio"
                  name="idPublicacionExposicion"
                  checked={idExposicionNueva === exposicion.idPublicacionExposicion}
                  value={exposicion.idPublicacionExposicion}
                  onChange={(e) => handleChange(e.target)}
                />
                Exposición {exposicion.nombre}
              </span>
            </ToolTip>
          ))}
        </div>
      </div>
    </div>
  )
}

Exposicion.propTypes = {
  idExposicionNueva: PropTypes.number.isRequired,
  idExposicionAnterior: PropTypes.number.isRequired,
  onChangeState: PropTypes.func.isRequired
}

export default Exposicion
